import { Link } from "react-router-dom"
import "./Banner.css"

const Banner = () => {
  return (
    <div id="main_slider" className="carousel slide" data-bs-ride="carousel">
      <div className="carousel-indicators">
        <button
          type="button"
          data-bs-target="#main_slider"
          data-bs-slide-to="0"
          className="active"
          aria-current="true"
          aria-label="Slide 1"
        ></button>
        <button type="button" data-bs-target="#main_slider" data-bs-slide-to="1" aria-label="Slide 2"></button>
        <button type="button" data-bs-target="#main_slider" data-bs-slide-to="2" aria-label="Slide 3"></button>
      </div>
      <div className="carousel-inner">
        <div className="carousel-item active">
          <div className="banner_section">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6 col-md-12">
                  <div className="banner-content">
                    <h1 className="banner_taital">
                      Orthopedic Surgeon
                      <span className="highlight-text">Dr. Sunil Apsingi</span>
                    </h1>
                    <p className="banner_text">
                      Over 23 years of experience in orthopedic and joint replacement surgery
                    </p>
                    <div className="btn_main">
                      <Link to="/bookappointment" className="btn btn-primary-custom">
                        Book Consultation
                      </Link>
                      <Link to="/contact" className="btn btn-secondary-custom">
                        Contact Now
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12">
                  <div className="banner-image">
                    <img src="images/2022-05-13.png" alt="Dr. Sunil Apsingi" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="carousel-item">
          <div className="banner_section">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6 col-md-12">
                  <div className="banner-content">
                    <h1 className="banner_taital">
                      <span className="highlight-text">Expert Orthopedic Care</span>
                    </h1>
                    <p className="banner_text">Providing comprehensive orthopedic solutions for a pain-free life</p>
                    <div className="btn_main">
                      <Link to="/services" className="btn btn-primary-custom">
                        Our Services
                      </Link>
                      <Link to="/contact" className="btn btn-secondary-custom">
                        Contact Now
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12">
                  <div className="banner-image">
                    <img src="images/image-(1).png" alt="Expert Orthopedic Care" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="carousel-item">
          <div className="banner_section">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6 col-md-12">
                  <div className="banner-content">
                    <h1 className="banner_taital">
                      <span className="highlight-text">Advanced Joint Replacement</span>
                    </h1>
                    <p className="banner_text">Specializing in knee and shoulder replacement surgeries</p>
                    <div className="btn_main">
                      <Link to="/bookappointment" className="btn btn-primary-custom">
                        Book Consultation
                      </Link>
                      <Link to="/contact" className="btn btn-secondary-custom">
                        Contact Now
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12">
                  <div className="banner-image">
                    <img src="images/image-(2).png" alt="Advanced Joint Replacement" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Previous Button */}
      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#main_slider"
        data-bs-slide="prev"
      >
        {/* Changed to standard bootstrap icon class */}
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      {/* Next Button */}
      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#main_slider"
        data-bs-slide="next"
      >
        {/* Changed to standard bootstrap icon class */}
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  )
}

export default Banner
